<template>
	<div>
		<ExpensesTabs
			v-if="claimId === 0"
			:tab="'Finance'"
			@tab="onTabChange($event)"			
		/>
		<div class="pb-2">
			<ClaimDetailTitle 
				class="head-title px-6 d-print-none" 
				:title="claim && `${claim.number} - ${claim.description}`" 
				:text="'Back to Finance'"
				:isClose="claimId !== 0 ? true : false"
				@back="onBack()"
			/>
			<ProgressGetDataLinear v-if="loading" class="px-5"/>
			<FinanceClaimContent
				v-if="!loading"
				class="ma-5"
				:color="color"
				:currencies="currencies"
				:error_message="error_msg"
				:claim="claim"
				:isPosted="(claim && claim.status !== posted_status) ? false : !isPosted "
				:postLoading="post_loading"
				:rejectLoading="visible_moreinfo"
				:forwardLoading="visible_forward"
				:deleteLoading="visible_delete"
				:printLoading="visible_print"
				:recoverLoading="visible_recover"
				:claimId="claimId"
				@row-click="onRowClick($event)"
				@date-change="onDateChange($event)"
				@period-change="onPeriodChange($event)"
				@desc-change="onDescChange($event)"
				@currency-change="onCurrencyChange($event)"
				@detail-delete="onDetailDeleteCheck($event)"
				@detail-split="onDetailSplit($event)"
				@duplicate-receipt="onReceipDuplicate($event)"
				@post-gl="onPostGL($event)"
				@more-info="onMoreInfoDialog()"
				@forward="onForwardDialog($event)"
				@delete="onDeleteDialog()"
				@print="onPrint($event)"
				@recover="onRecoverDialog()"
			/>
			<EditReceiptDialog 
				:key="'detail_edit_visible'"
				v-if="detail_edit_visible"
				:visible="detail_edit_visible" 
				:color="color" 
				:currencies="currencies"
				:receipt="receipt"
				:isFinance="true"
				@close="onClose() "
				@save="onDetailSave($event)"
				@update-file="onUpdateFile($event)"
				@copy="onGetImageData($event)"
			/>
			<EditReceiptDialog 
				:key="'receipt_edit_visible'"
				v-if="receipt_edit_visible"
				:visible="receipt_edit_visible" 
				:color="color" 
				:currencies="currencies"
				:receipt="receipt"
				:isFinance="true"
				:isDuplicate="true"
				:isMultiDuplicate="is_multi_duplicate"
				@cancel="onCancelDuplicate($event)"
				@more="onMore()"
				@copy="onGetImageData($event)"
			/>
			<ApprovalDialog 
				v-if="visible_moreinfo"
				key="moreinfo_detail"
				:visible="visible_moreinfo" 
				:color="color"
				:title_text="`More information required`"
				:suppliers="[claim.supplier]"
				@cancel="visible_moreinfo = false"
				@ok="onMoreInfo($event)"
			/>
			<ApprovalDialog 
				v-if="visible_forward"
				key="forward_detail"
				:visible="visible_forward" 
				:color="color"
				:title_text="`Forward claim to...`"
				:isFinance="true"
				:userID="user_abid"
				:confirm_button="`Submit`"
				@cancel="visible_forward = false"
				@submit="onForward($event)"
			/>
			<UnsavedConfirmDialog
				v-if="unsaved_confirm_visible"
				:visible="unsaved_confirm_visible"
				@cancel="onCancelUnsavedConfirm()"
				@ok="onDetailSave(null)"
			/>
			<DeleteConfirmDialog
				v-if="delete_confirm_visible"
				:visible="delete_confirm_visible"
				:title="`You are about to delete a receipt`"
				:content="`This action cannot be undone. Are you sure?`"
				:okText="`Delete`"
				@cancel="delete_confirm_visible = false"
				@ok="onDetailDelete(false)"
			/>
			<LeaveReceiptsDialog
				v-if="delete_last_confirm_visible"
				:visible="delete_last_confirm_visible"
				:type="'warning'"
				:icon="'mdi-alert-circle'"
				:title_text="`Claim has no expenses attached`"
				:content_text="`As this claim has no attached expenses, it will be deleted when you leave this window. Are you sure?`"
				:cancel_button="`Back`"
				:confirm_button="`Delete claim`"
				@cancel="delete_last_confirm_visible = false"
				@ok="onDetailDelete(true)"
			/>
			<DeleteConfirmDialog
				v-if="visible_delete"
				:visible="visible_delete"
				:title="`You are about to delete claim`"
				:content="`This action cannot be undone. Are you sure?`"
				:okText="`Delete`"
				@cancel="visible_delete = false"
				@ok="onDelete()"
			/>
			<RecoverDialog
				v-if="visible_recover"
				:visible="visible_recover"
				:textColor="color"
				:titleText="'Recover deleted claim?'"
				:userName="claim.supplier.display_name"
				@cancel="visible_recover = false"
				@ok="onRecover($event)"
			/>
			<DialogProgress
				v-if="progress_visible" 
				:visible="progress_visible" 
				:color="color"
				:note="`Duplicating`"
			/>
			<DialogNotice
				v-if="visible_notice" 
				:visible="visible_notice" 
				:text="notice_text"
				:isWarning="isWarning"
				:color="isWarning? '#FB8C00': '#00AAFD'"
			/>
			<DialogNotice
				v-if="visible_reposted_notice" 
				:visible="visible_reposted_notice" 
				:text="[`need to 'Approve + Post' again`]"
				:isWarning="isWarning"
				:color="isWarning? '#FB8C00': '#00AAFD'"
			/>
			<DialogProgress 
				v-if="visible_progress"
				:visible="visible_progress" 
				:color="color"
			/>
			<PrintClaims
				v-if="print_claims.length !== 0"  
				id="print"
				style="display: none"
				:printClaims="print_claims"
			/>
		</div>
	</div>
</template>
<script>
import ClaimDetailTitle from "@/views/expenses/commond/claim_detail_title.vue";
import FinanceClaimContent from "@/views/expenses/finance/finance_claim_content.vue";
import EditReceiptDialog from '@/views/expenses/commond/edit_receipt_dialog';
import UnsavedConfirmDialog from "@/views/expenses/commond/unsaved_confirm_dialog.vue";
import DeleteConfirmDialog from "@/views/expenses/commond/delete_confirm_dialog.vue";
import LeaveReceiptsDialog from "@/components/expenses/leave_receipts_dialog";
import DialogProgress from "@/components/dialogs/progress_dialog.vue";
import DialogNotice from "@/components/dialogs/notice_dialog.vue";
import ApprovalDialog from "@/views/expenses/approvals/approval_dialog.vue";
import PrintClaims from '@/components/expenses/print_claims';
import ExpensesTabs from "@/views/expenses/commond/expenses_tabs";
import ProgressGetDataLinear from "@/components/progress/progress_getdata_linear.vue";
import RecoverDialog from "@/views/expenses/commond/recover_dialog.vue";

import moment from 'moment';
import config from "@/config.js";

import * as pdfjsLib from 'pdfjs-dist/es5/build/pdf';
import pdfjsworker from 'pdfjs-dist/es5/build/pdf.worker.entry';
pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsworker;

const SCALE = 1.2;
const MAX_WIDTH = 600;
const PAGE_INIT = 0;

const CLAIM_STATUSES = config.claim_statuses;

export default {
	name: 'FinanceDetail',
	props: {
		claimId: {
			type: Number,
			default: 0
		}
	},
	data() {
		this.posted_status = CLAIM_STATUSES.posted.value;
		return {
			error_msg: '',
			loading: false,
			color: this.$attrs.color ? this.$attrs.color : '#FFB946',
			currencies: [],

			claim: null,
			receipt: null,
			receipt_id: null,
			update_receipt_obj: null,
			delete_detail_ids: null,
			duplicate_receipts: [],
			duplicate_copy_id: null,
			is_multi_duplicate: false,
			isPosted: false,

			visible_moreinfo: false,
			visible_forward: false,
			visible_delete: false,
			detail_edit_visible: false,
			receipt_edit_visible: false,
			unsaved_confirm_visible: false,
			delete_confirm_visible: false,
			delete_last_confirm_visible: false,
			progress_visible: false,
			visible_reposted_notice: false,
			isWarning: false,
			visible_notice: false,
			notice_text: [],
			tid: null,

			print_claims: [],
			image_arr: [],
			visible_progress: false,
			visible_print: false,
			visible_recover: false,
			post_loading: false
		}
	},
	components: {
		ClaimDetailTitle,
		FinanceClaimContent,
		EditReceiptDialog,
		UnsavedConfirmDialog,
		DeleteConfirmDialog,
		DialogProgress,
		DialogNotice,
		ApprovalDialog,
		PrintClaims,
		ExpensesTabs,
		ProgressGetDataLinear,
		RecoverDialog,
		LeaveReceiptsDialog
	},
	beforeDestroy() {
		if(this.tid) {
			clearTimeout(this.tid);
		}
	},
	created() {
		this.listCountries();
		this.update_breadcrumb();
		this.load_claim();
	},
	computed: {
		user_abid() {
			const user = this.$store.state.user;
			if (user && user.addressbook) {
				return user.addressbook.id
			} else {
				return 0;
			}
		},
	},
	methods: {
		listCountries() {
			const url = `/api/config/country`;

			return axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						if (data.length !== 0) {
							const currencies_by_id = new Map();

							data.forEach(country => {
								if (!country.currency) return;

								const { currency, ...country_details } = country;
								if (!currencies_by_id.has(currency.id)) {
									currencies_by_id.set(currency.id, Object.assign({}, currency, {
										countries: []
									}));
								}

								currencies_by_id.get(currency.id).countries.push(country_details);
							});

							this.currencies = Array.from(currencies_by_id.values());
						}
					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.loading = false;
				});
		},
		load_claim() {
			this.loading = true;
			const id = this.claimId !== 0 ? this.claimId : this.$route.params.id;
			const url = `/api/expenses/claims/${id}`;

			axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " +this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						this.claim = data;
						this.loading = false;
					} else {
						this.error_msg = reason;
						this.loading = false;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
					this.loading = false;
				});
		},
		onTabChange(current_tab) {
			if (this.isPosted) {
				this.visible_reposted_notice = true;
				this.tid = setTimeout(this._close, 2000);
			} else {
				this.$router.push({ name: current_tab });

			}
		},
		onBack() {
			if (this.claimId !== 0) {
				this.$emit('close');
			} else {
				if (this.isPosted) {
					this.visible_reposted_notice = true;
					this.tid = setTimeout(this._close, 2000);
				} else {
					this.$router.push({ name: 'Finance' });
				}
			}
		},
		onRowClick(detail) {
			const obj = detail.code;
			if (obj.display_name.includes(obj.code)) {
				obj['display_name'] = `${obj.display_name}`;
			} else {
				obj['display_name'] = `${obj.code} - ${obj.display_name}`;
			}		

			detail['job'] = obj;
			detail['gross'] = detail.gross;
			detail['markup_perc'] = detail.markup_perc !== undefined
				? detail.markup_perc
				: detail.markup;
			detail['tax_setting'] = { text: detail.tax_mode_desc, value: detail.tax_mode };
			this.receipt = detail;

			this.detail_edit_visible = true;
		},
		onDateChange(date) {
			const details = [];
			this.claim.details.forEach(detail => {
				details.push({
					receipt_id: detail.receipt.id,
					amount: Number(Number(detail.amount).toFixed(2)),
					description: detail.description,
					phase_id: detail.phase.id,
					job_id: detail.job.id,
					kind_id: detail.kind.id,
					gross: Number(Number(detail.gross).toFixed(2)),
					tax_mode: detail.tax_mode,
					tax_perc: Number(Number(detail.tax_perc).toFixed(2)),
					tax_amount: Number(Number(detail.tax_amount).toFixed(2)),
					markup: Number(Number(detail.markup).toFixed(2)),
					value_fc: Number(Number(detail.value_fc).toFixed(2)),
				});
			});

			const claim_obj = {
				supplier_id: this.claim.supplier.id,
				date: date,
				desc: this.claim.description,
				currency_id: this.claim.currency.id,
				approval_by: this.claim.approval_by ? this.claim.approval_by.id : null,
				status: this.claim.status,
				remark: this.claim.remark,
				period_id: this.claim.period.id,
				details: details
			};
			
			this._update_claim(this.claim.id, claim_obj);
		},
		onPeriodChange(period_obj) {
			const details = [];
			this.claim.details.forEach(detail => {
				details.push({
					receipt_id: detail.receipt.id,
					amount: Number(Number(detail.amount).toFixed(2)),
					description: detail.description,
					phase_id: detail.phase.id,
					job_id: detail.job.id,
					kind_id: detail.kind.id,
					gross: Number(Number(detail.gross).toFixed(2)),
					tax_mode: detail.tax_mode,
					tax_perc: Number(Number(detail.tax_perc).toFixed(2)),
					tax_amount: Number(Number(detail.tax_amount).toFixed(2)),
					markup: Number(Number(detail.markup).toFixed(2)),
					value_fc: Number(Number(detail.value_fc).toFixed(2)),
				});
			});
			const claim_obj = {
				supplier_id: this.claim.supplier.id,
				date: period_obj.date,
				period_id: period_obj.period.id,
				desc: this.claim.description,
				currency_id: this.claim.currency.id,
				approval_by: this.claim.approval_by ? this.claim.approval_by.id : null,
				status: this.claim.status,
				remark: this.claim.remark,
				details: details
			};
			
			this._update_claim(this.claim.id, claim_obj);
		},
		onDescChange(description) {
			const details = [];
			this.claim.details.forEach(detail => {
				details.push({
					receipt_id: detail.receipt.id,
					amount: Number(Number(detail.amount).toFixed(2)),
					description: detail.description,
					phase_id: detail.phase.id,
					job_id: detail.job.id,
					kind_id: detail.kind.id,
					gross: Number(Number(detail.gross).toFixed(2)),
					tax_mode: detail.tax_mode,
					tax_perc: Number(Number(detail.tax_perc).toFixed(2)),
					tax_amount: Number(Number(detail.tax_amount).toFixed(2)),
					markup: Number(Number(detail.markup).toFixed(2)),
					value_fc: Number(Number(detail.value_fc).toFixed(2)),
				});
			});
			const claim_obj = {
				supplier_id: this.claim.supplier.id,
				date: this.claim.date,
				desc: description,
				currency_id: this.claim.currency.id,
				approval_by: this.claim.approval_by ? this.claim.approval_by.id : null,
				status: this.claim.status,
				remark: this.claim.remark,
				period_id: this.claim.period.id,
				details: details
			};
			
			this._update_claim(this.claim.id, claim_obj);
		},
		async onCurrencyChange(currency) {
			const rate_old = await this._get_exchange_rate(this.claim.currency.id, this.claim.date);
			const rate_new = await this._get_exchange_rate(currency.id, this.claim.date);
			const details = [];

			this.claim.details.forEach(detail => {
				console.log("Convert from ", 'currency code:', this.claim.currency.id, ' value:', detail.amount, 'exrate:', rate_old);
				const amount_new = (rate_new * (detail.amount / rate_old)).toFixed(2);
				const gross_new = (rate_new * (detail.gross / rate_old)).toFixed(2);
				const tax_amount_new = (rate_new * (detail.tax_amount / rate_old)).toFixed(2);
				const value_fc_new = (rate_new * (detail.value_fc / rate_old)).toFixed(2);
				console.log("Convert from ", 'currency code:', currency.id, ' value:', amount_new, 'exrate:', rate_new);

				details.push({
					receipt_id: detail.receipt.id,
					amount: Number(amount_new),
					description: detail.description,
					phase_id: detail.phase.id,
					job_id: detail.job.id,
					kind_id: detail.kind.id,
					gross: Number(gross_new),
					tax_mode: detail.tax_mode,
					tax_perc: Number(Number(detail.tax_perc).toFixed(2)),
					tax_amount: Number(tax_amount_new),
					markup: Number(Number(detail.markup).toFixed(2)),
					value_fc: Number(value_fc_new),
				});
			});

			const claim_obj = {
				supplier_id: this.claim.supplier.id,
				date: this.claim.date,
				desc: this.claim.description,
				currency_id: currency.id,
				approval_by: this.claim.approval_by ? this.claim.approval_by.id : null,
				status: this.claim.status,
				remark: this.claim.remark,
				period_id: this.claim.period.id,
				details: details
			};
			
			this._update_claim(this.claim.id, claim_obj);
		},
		async onDetailSave(update_detail) {
			const update_detail_tmp = update_detail ? update_detail : this.update_receipt_obj;
			const is_new_receipt = Number(update_detail_tmp.id) < 0;
			let receipt_id = update_detail_tmp.id;
			let created_receipt = null;

			if (is_new_receipt) {
				created_receipt = await this._postReceipt();
				if (!created_receipt) return;

				receipt_id = created_receipt.id;
			}

			const gross = update_detail_tmp.gross !== undefined
				? Number(update_detail_tmp.gross)
				: Number(update_detail_tmp.value);
			const markup_perc = Number(update_detail_tmp.markup_perc) || 0;
			const updated_claim_detail = {
				receipt_id: receipt_id,
				amount: update_detail_tmp.amount,
				description: update_detail_tmp.description,
				phase_id: update_detail_tmp.phase.id,
				job_id: update_detail_tmp.job.id,
				kind_id: update_detail_tmp.kind.id,
				gross: gross,
				tax_mode: update_detail_tmp.tax_mode,
				tax_amount: update_detail_tmp.tax_amount,
				tax_perc: update_detail_tmp.tax_perc,
				markup: markup_perc,
				value_fc: this._getMarkupValue(gross, markup_perc),
			};
			const details = this.claim.details.map(detail => {
				if (!is_new_receipt && detail.receipt.id === receipt_id) {
					return updated_claim_detail;
				}

				const detail_markup = detail.markup !== undefined
					? detail.markup
					: detail.markup_perc;

				return {
					receipt_id: detail.receipt.id,
					amount: detail.amount,
					description: detail.description,
					phase_id: detail.phase.id,
					job_id: detail.job.id,
					kind_id: detail.kind.id,
					gross: detail.gross,
					tax_mode: detail.tax_mode,
					tax_amount: detail.tax_amount,
					tax_perc: detail.tax_perc,
					markup: detail_markup,
					value_fc: this._getMarkupValue(detail.gross, detail_markup),
				};
			});

			if (is_new_receipt) {
				details.push(updated_claim_detail);
			}

			const claim_obj = {
				supplier_id: this.claim.supplier.id,
				date: this.claim.date,
				desc: this.claim.description,
				currency_id: this.claim.currency.id,
				approval_by: this.claim.approval_by ? this.claim.approval_by.id : null,
				status: this.claim.status,
				remark: this.claim.remark,
				period_id: this.claim.period.id,
				details: details
			};

			const new_receipt = {
				id: receipt_id,
				desc: update_detail_tmp.description === null || update_detail_tmp.description === undefined ? update_detail_tmp.desc : update_detail_tmp.description,
				date: moment(update_detail_tmp.date).format("YYYY-MM-DD"),
				currency_id: update_detail_tmp.currency.id,
				gross: typeof(update_detail_tmp.value) === 'string' ? this.parseAmount(update_detail_tmp.value) : Number(update_detail_tmp.value.toFixed(2)),
				has_tax: update_detail_tmp.has_tax ? 1 : 0,
				job_id: update_detail_tmp.job.id,
				phase_id: update_detail_tmp.phase.id,
				kind_id: update_detail_tmp.kind.id,
				tax_mode: update_detail_tmp.tax_mode,
				tax_perc: typeof(update_detail_tmp.tax_perc) === 'string' ? this.parseAmount(update_detail_tmp.tax_perc) : Number(update_detail_tmp.tax_perc.toFixed(2)),  
				tax_amount: typeof(update_detail_tmp.tax_amount) === 'string' ? this.parseAmount(update_detail_tmp.tax_amount) : Number(update_detail_tmp.tax_amount.toFixed(2)), 
				markup_perc: typeof(update_detail_tmp.markup_perc) === 'string' ? this.parseAmount(update_detail_tmp.markup_perc) : Number(update_detail_tmp.markup_perc.toFixed(2)), 
				value: typeof(update_detail_tmp.markup_value) === 'string' ? this.parseAmount(update_detail_tmp.markup_value) : Number(update_detail_tmp.markup_value.toFixed(2)), 
			};

			if (update_detail_tmp.employee) {
				new_receipt['employee_id'] = update_detail_tmp.employee.id;
			} else if (is_new_receipt) {
				new_receipt['employee_id'] = this.claim.supplier.id;
			}

			await this._updateReceipt(new_receipt, claim_obj);
		},
		async onDetailSplit(details_with_splits) {
			const details = [];
			const new_split_receipt_ids = [];

			for (let index = 0; index < details_with_splits.length; index++) {
				const detail = details_with_splits[index];

				if (Number(detail.id) >= 0) {
					details.push({
						receipt_id: detail.receipt.id,
						amount: detail.amount,
						description: detail.description,
						phase_id: detail.phase.id,
						job_id: detail.job.id,
						kind_id: detail.kind.id,
						gross: detail.gross,
						tax_mode: detail.tax_mode,
						tax_amount: detail.tax_amount,
						tax_perc: detail.tax_perc,
						markup: detail.markup,
						value_fc: detail.value_fc
					});
					continue;
				}

				const created_receipt = await this._postReceipt();
				if (!created_receipt) return;

				const receipt_obj = {
					employee_id: created_receipt.employee.id,
					desc: detail.description || '',
					date: moment(detail.receipt.date).format("YYYY-MM-DD"),
					currency_id: detail.receipt.currency.id,
					gross: Number(detail.gross) || 0,
					has_tax: detail.has_tax ? 1 : 0,
					job_id: detail.job.id,
					phase_id: detail.phase.id,
					kind_id: detail.kind.id,
					tax_mode: detail.tax_mode,
					tax_perc: Number(detail.tax_perc) || 0,
					tax_amount: Number(detail.tax_amount) || 0,
					markup_perc: Number(detail.markup) || 0,
					value: Number(detail.value_fc) || 0
				};

				const receipt_updated = await this._updateSplitReceipt(created_receipt.id, receipt_obj);
				if (!receipt_updated) return;
				new_split_receipt_ids.push(created_receipt.id);

				details.push({
					receipt_id: created_receipt.id,
					amount: Number(detail.amount) || 0,
					description: detail.description || '',
					phase_id: detail.phase.id,
					job_id: detail.job.id,
					kind_id: detail.kind.id,
					gross: Number(detail.gross) || 0,
					tax_mode: detail.tax_mode,
					tax_amount: Number(detail.tax_amount) || 0,
					tax_perc: Number(detail.tax_perc) || 0,
					markup: Number(detail.markup) || 0,
					value_fc: Number(detail.value_fc) || 0
				});
			}

			const claim_obj = {
				supplier_id: this.claim.supplier.id,
				date: this.claim.date,
				desc: this.claim.description,
				currency_id: this.claim.currency.id,
				approval_by: this.claim.approval_by ? this.claim.approval_by.id : null,
				status: this.claim.status,
				remark: this.claim.remark,
				period_id: this.claim.period.id,
				details: details
			};

			const detail_order = details.map(detail => detail.receipt_id);
			this._update_claim(this.claim.id, claim_obj, false, detail_order, new_split_receipt_ids);
		},
		onDetailDeleteCheck(id) {
			this.delete_detail_ids = Array.isArray(id)? id : [id];

			const status_able = this.claim.status === CLAIM_STATUSES.draft.value
				|| this.claim.status === CLAIM_STATUSES.pending.value
				|| this.claim.status === CLAIM_STATUSES.approved.value
				|| this.claim.status === CLAIM_STATUSES.rejected.value
				|| this.claim.status === CLAIM_STATUSES.posted.value

			if (this.delete_detail_ids.length === this.claim.details.length && status_able) {
				this.delete_last_confirm_visible = true;
			} else {
				this.delete_confirm_visible = true;
			}
		},
		onDetailDelete(is_delete_claim) {
			if (is_delete_claim) {
				const claim_obj = {
					supplier_id: this.claim.supplier.id,
					date: this.claim.date,
					desc: this.claim.description,
					currency_id: this.claim.currency.id,
					approval_by: this.claim.approval_by ? this.claim.approval_by.id : null,
					status: this.claim.status,
					remark: this.claim.remark,
					submitted_date: this.claim.submitted_date,
					period_id: this.claim.period.id,
					details: [],
				}

				this._update_claim(this.claim.id, claim_obj, true);

			} else {
				const details_origin = this.claim.details;
				const details = [];
				details_origin.forEach(detail => {
					const receipt_id = detail.receipt ? detail.receipt.id :detail.id;
				
					if (!this.delete_detail_ids.includes(receipt_id)) {
						details.push({
							receipt_id: detail.receipt.id,
							amount: Number(Number(detail.amount).toFixed(2)),
							description: detail.description,
							phase_id: detail.phase.id,
							job_id: detail.job.id,
							kind_id: detail.kind.id,
							gross: Number(Number(detail.gross).toFixed(2)),
							tax_mode: detail.tax_mode,
							tax_perc: Number(Number(detail.tax_perc).toFixed(2)),
							tax_amount: Number(Number(detail.tax_amount).toFixed(2)),
							markup: Number(Number(detail.markup).toFixed(2)),
							value_fc: Number(Number(detail.value_fc).toFixed(2)),
						});
					}
				});

				const claim_obj = {
					supplier_id: this.claim.supplier.id,
					date: this.claim.date,
					desc: this.claim.description,
					currency_id: this.claim.currency.id,
					approval_by: this.claim.approval_by ? this.claim.approval_by.id : null,
					status: this.claim.status,
					remark: this.claim.remark,
					submitted_date: this.claim.submitted_date,
					period_id: this.claim.period.id,
					details: details,
				}
				this._update_claim(this.claim.id, claim_obj);
			}
		},
		onClose() {
			this.detail_edit_visible = false;
		},
		onCancelUnsavedConfirm() {
			this.unsaved_confirm_visible = false;
			this.detail_edit_visible = false;
		},
		onReceipDuplicate(receipt_arr) {
			this.is_multi_duplicate = receipt_arr.length === 1 ? false : true;
			
			this.duplicate_receipts = receipt_arr.sort((a,b) => { return a-b });
			this.receipt = this.duplicate_receipts[0];
			this.receipt_edit_visible = true;
		},
		onCancelDuplicate(receipt_id) {
			if (this.duplicate_receipts.length === 1) {
				this.receipt = null;
				this.is_multi_duplicate = false;
				this.receipt_edit_visible = false;
			} else {
				this.duplicate_receipts = this.duplicate_receipts.filter(duplicate => { return duplicate.id !== receipt_id });

				this.receipt = null;
				this.receipt = this.duplicate_receipts[0];
				if (this.duplicate_receipts.length === 1) {
					this.is_multi_duplicate = false;
				}
			}
		},
		onMore() {
			const arr_tmp = this.duplicate_receipts;

			const out_id = arr_tmp.shift();
			arr_tmp.push(out_id);

			this.receipt = null;
			this.receipt = this.duplicate_receipts[0];
		},
		async onGetImageData(receipt) {
			await this.onDetailSave(receipt.update);

			const new_receipt = receipt.new;

			this.duplicate_copy_id = new_receipt.id;
			this.progress_visible = true;
			if (new_receipt.image) {
				const url = new_receipt.image;
				axios
					.get(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json",
						},
						responseType: 'blob',
					})
					.then((val) => {
						const { status, data } = val;

						if (status === 200) {
							this._createReceipt(data, new_receipt);
						} 
					})
					.catch((e) => {
						this.error_msg = e.message;
					});
			} else {
				const blob = new Blob([''], {type : 'image/jpeg'});
				this._createReceipt(blob, new_receipt);
			}
		},
		onPostGL() { 
			if (this.post_loading) return;

			this._post_gl(this.claim.id);
		},
		onMoreInfoDialog() {
			if (this.visible_moreinfo) return;

			this.visible_moreinfo = true;
		},
		onMoreInfo(reason) {
			const reason_with_date = `${reason}${config.remark_date_flag}${moment().format('YYYY-MM-DD')}`;

			const details = [];
			this.claim.details.forEach(detail => {
				details.push({
					receipt_id: detail.receipt.id,
					amount: Number(Number(detail.amount).toFixed(2)),
					description: detail.description,
					phase_id: detail.phase.id,
					job_id: detail.job.id,
					kind_id: detail.kind.id,
					gross: Number(Number(detail.gross).toFixed(2)),
					tax_mode: detail.tax_mode,
					tax_perc: Number(Number(detail.tax_perc).toFixed(2)),
					tax_amount: Number(Number(detail.tax_amount).toFixed(2)),
					markup: Number(Number(detail.markup).toFixed(2)),
					value_fc: Number(Number(detail.value_fc).toFixed(2)),
				});
			});
			const claim_obj = {
				supplier_id: this.claim.supplier.id,
				date: this.claim.date,
				desc: this.claim.description,
				currency_id: this.claim.currency.id,
				approval_by: this.claim.approval_by ? this.claim.approval_by.id : null,
				status: CLAIM_STATUSES.rejected.value,
				remark: reason_with_date,
				period_id: this.claim.period.id,
				details: details
			};

			this._update_claim(this.claim.id, claim_obj);
		},
		onForwardDialog() {
			if (this.visible_forward) return;

			this.visible_forward = true;
		},
		async onForward(event) {
			const details = [];
			this.claim.details.forEach(detail => {
				details.push({
					receipt_id: detail.receipt.id,
					amount: Number(Number(detail.amount).toFixed(2)),
					description: detail.description,
					phase_id: detail.phase.id,
					job_id: detail.job.id,
					kind_id: detail.kind.id,
					gross: Number(Number(detail.gross).toFixed(2)),
					tax_mode: detail.tax_mode,
					tax_perc: Number(Number(detail.tax_perc).toFixed(2)),
					tax_amount: Number(Number(detail.tax_amount).toFixed(2)),
					markup: Number(Number(detail.markup).toFixed(2)),
					value_fc: Number(Number(detail.value_fc).toFixed(2)),
				});
			});
			const claim_obj = {
				supplier_id: this.claim.supplier.id,
				date: this.claim.date,
				desc: this.claim.description,
				currency_id: this.claim.currency.id,
				approval_by: event.approval_by.id,
				status: this.claim.status,
				remark: event.reason,
				period_id: this.claim.period.id,
				send_email: true,
				details: details
			};

			this._update_claim(this.claim.id, claim_obj);
		},
		onDeleteDialog() {
			if (this.visible_delete) return;

			this.visible_delete = true;
		},
		onDelete() {
			this._delete_claim(this.claim.id);
		},
		async onPrint(amount) {
			if (this.visible_print) return;

			this.visible_progress = true;
			this.visible_print = true;
			this.print_claims = [];
			const receipt_with_image  = this.claim.details.filter(d => { return d.receipt.image_type.length !== 0 });
			
			const image_blob_arr = [];
			for (let index = 0; index < receipt_with_image.length; index++) {
				const detail = receipt_with_image[index];
				const url = `/api/expenses/receipts/${detail.receipt.id}/image`;
				await axios
					.get(url, {
						headers: {
							"Authorization": "Bearer " + this.$store.state.token,
							"Accept": "application/json"
						},
						responseType: 'blob',
					})
					.then((val) => {
						const { status, data } = val;
						if (status === 200) {
							const data_obj = {
								id: this.claim.id,
								data: data
							};
							image_blob_arr.push(data_obj);
						}
					})
					.catch((e) => {
						this.$emit('error-msg', e.message);
					});
			}

			if (image_blob_arr.length === 0) {
				this.setPrintItem(amount);
			} else {
				this.getImageList(image_blob_arr, amount);
			}	
		},
		onRecoverDialog() {
			if (this.visible_recover) return;

			this.visible_recover = true;
		},
		onRecover(reason) {
			this._recover_claim(this.claim.id, reason);
		},
		getImageList(image_blob_arr, amount) {
			for (let index = 0; index < image_blob_arr.length; index++) {
				const image_blob = image_blob_arr[index];
				if (image_blob.data.type === 'application/pdf') {
					const reader = new FileReader();
					reader.readAsDataURL(image_blob.data);
					reader.onload = readerEvent =>  {
						const loadingTask = pdfjsLib.getDocument(readerEvent.target.result);
						loadingTask.promise.then(pdf => {
							const preview_url = [];
							let page_total = pdf.numPages;

							for (let index = 0; index < pdf.numPages; index++) {
								pdf.getPage(index + 1).then(page => {
									const scale = SCALE;
									const viewport = page.getViewport({scale: scale});

									const canvas = document.createElement('canvas');
									const context = canvas.getContext('2d');
									canvas.width = viewport.width;
									canvas.height = viewport.height;

									const renderContext = {
										canvasContext: context,
										viewport: viewport
									};

									const renderTask = page.render(renderContext);
									renderTask.promise.then(() => {
										canvas.toBlob(blob => {
											const preview_item_url = URL.createObjectURL(blob);
											preview_url.push(preview_item_url);
											page_total -= 1;

											if (page_total === PAGE_INIT) {
												const dimension = this.getDimension(viewport.width, viewport.height);
												const image_obj = {
													id: image_blob.id,
													width: dimension.width,
													height: dimension.height,
													image: preview_url
												};
												this.image_arr.push(image_obj);

												if (this.image_arr.length === image_blob_arr.length) {
													this.setPrintItem(amount);
												}
											}
										});									
									});
								});
							}
						});
					};
				} else {
					const my_image = new Image();
					const preview_item_url = URL.createObjectURL(image_blob.data);
					my_image.src = preview_item_url;
					my_image.onload = () => {
						const dimension = this.getDimension(my_image.width, my_image.height);
						const image_obj = {
							id: image_blob.id,
							width: dimension.width,
							height: dimension.height,
							image: preview_item_url
						};
						this.image_arr.push(image_obj);

						if (this.image_arr.length === image_blob_arr.length) {
							this.setPrintItem(amount);
						}
					}
				}				
			}
		},
		getDimension(width, height) {
			let image_width = 0;
			let image_height = 0;

			if (this.$vuetify.breakpoint.smAndDown) {
				/* 48 = padding-left-24px + padding-right-24px */
				if (width > height) {
					image_width = this.$vuetify.breakpoint.width - 48;
					image_height = (this.$vuetify.breakpoint.width - 48) * height / width;
				} else {
					image_height = this.$vuetify.breakpoint.width - 48;
					image_width = (this.$vuetify.breakpoint.width - 48) * width / height;
				}
			} else {
				if (width > height) {
					image_width = MAX_WIDTH;
					image_height = MAX_WIDTH * height / width;
				} else {
					image_height = MAX_WIDTH;
					image_width = MAX_WIDTH * width / height;
				}
			}

			return { width: image_width, height: image_height };
		},
		setPrintItem(amount) {
			this.print_claims = [];
			const obj = {
				id: this.claim.id,
				number: this.claim.number,
				desc: this.claim.description,
				submitted_date: this.claim.submitted_date,
				value: amount,
				currency: this.claim.currency.symbol,
				approval_by: this.claim.approval_by ? this.claim.approval_by.display_name : '',
				employee: this.claim.supplier.display_name,
				supplier: this.claim.supplier.display_name,
				claim_date: this.claim.date,
				details: this.claim.details,
				image_arr: this.image_arr
			}

			this.print_claims.push(obj);
			this.visible_progress = false;

			setTimeout(() => { 
				const printHtml = document.getElementById("print").innerHTML;
				const printFrame = document.createElement('iframe');
				printFrame.srcdoc = printHtml;
				document.body.appendChild(printFrame);

				printFrame.onload = () => {
					printFrame.contentWindow.print();
					
					const mql = printFrame.contentWindow.matchMedia('print');
					mql.onchange = (e) => {
						if (e.matches) {
							/* before print */
						} else {
							/* after print */
							document.body.removeChild(printFrame);
							this.visible_print = false;
							this.image_arr = [];
						}
					}
				}
			},20);
		},
		onUpdateFile(file_obj) {
			const receipt_tmp = JSON.parse(JSON.stringify(this.receipt));
			receipt_tmp.image = file_obj.image;
			receipt_tmp.image_type = file_obj.image_type;
			this.receipt = receipt_tmp;
			this.load_claim();
		},
		update_breadcrumb() {
			// add this page to our breadcrumbs
			this.$store.commit("push_breadcrumb", {
				exact: true,
				text: `Finance Claim ${this.$route.params.id}`,
				to: `/expenses/finance/${this.$route.params.id}`
			});
		},
		_postReceipt() {
			const blob = new Blob([''], {type: 'image/jpeg'});
			const url = "/api/expenses/receipts";

			return axios
				.post(url, blob, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						return data;
					}

					this.error_msg = reason;
					return null;
				})
				.catch((e) => {
					this.error_msg = e.message;
					return null;
				});
		},
		_updateSplitReceipt(receipt_id, receipt_obj) {
			const url = "/api/expenses/receipts/" + receipt_id;

			return axios
				.put(url, receipt_obj, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") return true;

					this.error_msg = reason;
					return false;
				})
				.catch((e) => {
					this.error_msg = e.message;
					return false;
				});
		},
		_createReceipt(blob_data, origin_receipt) {
			const url = "/api/expenses/receipts";
			axios
				.post(url, blob_data, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						const new_receipt = {
							id: data.id,
							employee_id: data.employee.id,
							desc: origin_receipt.desc,
							date: moment(origin_receipt.date).format("YYYY-MM-DD"),
							currency_id: origin_receipt.currency.id,
							value: 1.0 * origin_receipt.value,
							has_tax: origin_receipt.has_tax ? 1 : 0,
							job_id: origin_receipt.job.id,
							phase_id: origin_receipt.phase.id,
							kind_id: origin_receipt.kind.id,
							amount: origin_receipt.amount,
							gross: origin_receipt.gross,
							tax_amount: origin_receipt.tax_amount,
							tax_mode: origin_receipt.tax_mode
						};
						this._updateReceipt(new_receipt);
					} else {
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				})
		},
		async _updateReceipt(item, claim_obj=null) {
			const url = "/api/expenses/receipts/" + item.id;

			await axios
				.put(url, item, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json",
					}
				})
				.then(async (val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						if (claim_obj) {
							this._update_claim(this.claim.id, claim_obj);
						} else {
							const new_detail = data;
							new_detail['amount'] = item.amount;
							new_detail['gross'] = item.gross;
							new_detail['tax_amount'] = item.tax_amount;
							new_detail['tax_mode'] = item.tax_mode;
							await this._addDetail(new_detail);
						}
					} else {
						this.error_msg = reason;
						this.unsaved_confirm_visible = false;
						if (this.receipt_edit_visible) {
							this.receipt_edit_visible = false;
						}
					}
				})
				.catch((e) => {
					this.error_msg = e.message;
				});	
		},
		async _addDetail(pre_add_detail) {
			const details = [];
			this.claim.details.forEach(detail => {
				details.push({
					receipt_id: detail.receipt.id,
					amount: Number(Number(detail.amount).toFixed(2)),
					description: detail.description,
					phase_id: detail.phase.id,
					job_id: detail.job.id,
					kind_id: detail.kind.id,
					gross: Number(Number(detail.gross).toFixed(2)),
					tax_mode: detail.tax_mode,
					tax_perc: Number(Number(detail.tax_perc).toFixed(2)),
					tax_amount: Number(Number(detail.tax_amount).toFixed(2)),
					markup: Number(Number(detail.markup).toFixed(2)),
					value_fc: Number(Number(detail.value_fc).toFixed(2)),
				});
			});

			let amount_new = pre_add_detail.value;
			if (pre_add_detail.currency.id !== this.claim.currency.id) {
				const rate_pre = await this._get_exchange_rate(pre_add_detail.currency.id, pre_add_detail.date);
				const rate_current = await this._get_exchange_rate(this.claim.currency.id, this.claim.date);

				console.log("Convert from ", 'currency code:', pre_add_detail.currency.id, ' value:', pre_add_detail.value, 'exrate:', rate_pre);
				amount_new = (rate_current * (pre_add_detail.value / rate_pre)).toFixed(2);
				console.log("Convert from ", 'currency code:',  this.claim.currency.id  , ' value:', amount_new, 'exrate:', rate_current);				
			}

			details.push({
				receipt_id: pre_add_detail.id,
				amount: Number(amount_new),
				description: detail.description,
				phase_id: detail.phase.id,
				job_id: detail.job.id,
				kind_id: detail.kind.id,
				gross: Number(pre_add_detail.pre_add_detail),
				tax_mode: pre_add_detail.tax_mode,
				tax_perc: Number(Number(detail.tax_perc).toFixed(2)),
				tax_amount: Number(pre_add_detail.tax_amount),
				markup: Number(Number(detail.markup).toFixed(2)),
				value_fc: Number(Number(detail.value_fc).toFixed(2)),
			});

			const update_claim = {
				supplier_id: this.claim.supplier.id,
				date: this.claim.date,
				desc: this.claim.description,
				currency_id: this.claim.currency.id,
				approval_by: this.claim.approval_by ? this.claim.approval_by.id : null,
				status: this.claim.status,
				remark: this.claim.remark,
				submitted_date: this.claim.submitted_date,
				period_id: this.claim.period.id,
				details: details,
			};
			this._update_claim(this.claim.id, update_claim);
		},	
		_update_claim(id, update_obj, is_from_delete=false, detail_order=[], new_split_receipt_ids=[]) {
			const url = "/api/expenses/claims/" + id;
			const highlighted_receipt_ids = new Set(new_split_receipt_ids);
			if (this.claim && Array.isArray(this.claim.details)) {
				this.claim.details.forEach(detail => {
					if (detail.is_new_split && detail.receipt) {
						highlighted_receipt_ids.add(detail.receipt.id);
					}
				});
			}
			const requested_detail_order = detail_order.length !== 0
				? detail_order
				: (Array.isArray(update_obj.details)
					? update_obj.details.map(detail => detail.receipt_id)
					: []);

			axios
				.put(url, update_obj, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						if (Array.isArray(data.details) && highlighted_receipt_ids.size !== 0) {
							data.details.forEach(detail => {
								if (detail.receipt && highlighted_receipt_ids.has(detail.receipt.id)) {
									detail.is_new_split = true;
								}
							});
						}

						if (is_from_delete) {
							this._delete_claim(data.id);
						} else {
							if (requested_detail_order.length !== 0 && Array.isArray(data.details)) {
								const order_by_receipt = new Map(
									requested_detail_order.map((receipt_id, index) => [receipt_id, index])
								);

								data.details.sort((detail_a, detail_b) => {
									const index_a = order_by_receipt.get(detail_a.receipt.id);
									const index_b = order_by_receipt.get(detail_b.receipt.id);

									const position_a = index_a === undefined ? Number.MAX_SAFE_INTEGER : index_a;
									const position_b = index_b === undefined ? Number.MAX_SAFE_INTEGER : index_b;

									return position_a - position_b;
								});
							}

							this.claim = data;

							this.unsaved_confirm_visible = false;

							if (this.delete_confirm_visible) {
								this.delete_confirm_visible = false;
								this.claim = null;
								this.claim = data;
							}
							if (this.delete_last_confirm_visible) {
								this.delete_last_confirm_visible = false;
								this.claim = null;
								this.claim = data;
							}
							if (this.detail_edit_visible) {
								this.detail_edit_visible = false;
							}
							if (this.visible_moreinfo) {
								this.visible_moreinfo = false;
								this.onBack();
							}
							if (this.visible_forward) {
								this.visible_forward = false;
								this.onBack();
							}
							if (this.progress_visible) {
								this.progress_visible = false;
								this.onCancelDuplicate(this.duplicate_copy_id);
								this.notice_text.push('Expense successfully created.');
								this.visible_notice = true;
								this.tid = setTimeout(this._close, 2000);

								this.claim = null;
								this.claim = data;
							}
							if (this.visible_recover) {
								this.visible_recover = false;
								this.onBack();
							}
						}
						
					} else {
						this.error_msg = reason;
						this.unsaved_confirm_visible = false;
						this.delete_confirm_visible = false;
						if (this.detail_edit_visible) {
							this.detail_edit_visible = false;
						}
						if (this.progress_visible) {
							this.progress_visible = false;
						}
						if (this.receipt_edit_visible) {
							this.receipt_edit_visible = false;
						}
						if (this.visible_moreinfo) {
							this.visible_moreinfo = false;
						}
						if (this.visible_forward) {
							this.visible_forward = false;
						}
						if (this.visible_recover) {
							this.visible_recover = false;
						}
					}
				})
				.catch(e => {
					this.error_msg = e.message;
					this.unsaved_confirm_visible = false;
					this.delete_confirm_visible = false;
					if (this.detail_edit_visible) {
						this.detail_edit_visible = false;
					}
					if (this.receipt_edit_visible) {
						this.receipt_edit_visible = false;
					}
					if (this.visible_moreinfo) {
						this.visible_moreinfo = false;
					}
					if (this.visible_forward) {
						this.visible_forward = false;
					}
					if (this.progress_visible) {
						this.progress_visible = false;
					}
				});
		},
		async _delete_claim(id) {
			const url = `/api/expenses/claims/${id}`;
			await axios
				.delete(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						if (this.visible_delete) {
							this.visible_delete = false;
						}
						if (this.delete_last_confirm_visible) {
							this.delete_last_confirm_visible = false;
						}

						this.onBack();

					} else {
						if (this.visible_delete) {
							this.visible_delete = false;
						}

						if (this.delete_last_confirm_visible) {
							this.delete_last_confirm_visible = false;
						}

						this.error_msg = reason;
					}
				})
				.catch(e => {
					if (this.visible_delete) {
						this.visible_delete = false;
					}

					if (this.delete_last_confirm_visible) {
						this.delete_last_confirm_visible = false;
					}

					this.error_msg = e.message;
				})
				.finally(() => {
					if (this.visible_delete) {
						this.visible_delete = false;
					}
						
					if (this.delete_last_confirm_visible) {
						this.delete_last_confirm_visible = false;
					}
				});
		},
		async _recover_claim(id, reason) {
			const url = `/api/expenses/claims/${id}/reactivate?remark=${reason}`;

			await axios
				.post(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						this.visible_recover = false;
						this.onBack();
						
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.visible_recover = false;
				});
		},
		_post_gl(id) {
			this.post_loading = true;

			const url = `/api/supplier_invoice/${id}/transaction`
			axios
				.post(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const { status, reason } = val.data;

					if (status == "OK") {
						this.onBack();
					} else {
						this.error_msg = reason;
					}
				})
				.catch(e => {
					this.error_msg = e.message;
				})
				.finally(() => {
					this.post_loading = false;
				});
		},
		async _get_exchange_rate(currency_id, date) {
			let rate = null;
			const url = "/api/config/currency/" + currency_id + "/exchange_rates/" + date;

			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then(val => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						rate = data.rate;
					} else {
						this.error_msg = reason;
					}					
				})
				.catch((e) => {
					this.error_msg = e.message;
				});
			
			return rate;
		},
		_close() {
			this.visible_notice = false;
			this.visible_reposted_notice = false;
			this.isWarning = false;
			this.notice_text = [];
		},
		parseAmount(value) {
			// from string to nmber, 12,345.00 -> 12345.00 
			const amount = Number(String(value).replace(/,/g, ''));

			return Number.isNaN(amount) ? 0 : amount;
		},
		_getMarkupValue(amount, markup_perc) {
			const amount_tmp = Number(amount) || 0;
			const mark_up_tmp = Number(markup_perc) || 0;
			const markup_value = amount_tmp + (amount_tmp * mark_up_tmp * 0.01);

			return  Number(markup_value.toFixed(2));
		},
	}
}
</script>
<style lang="scss" scoped>
.head-title {
  height: 68px;
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  background: #FFFFFF;
  box-shadow: inset 0px 3px 5px rgba(0, 0, 0, 0.1);
}
.hidden {
	display: none;
}
</style>
